// extracted by mini-css-extract-plugin
export var actionButton = "_r5-0";
export var actionMenuContainer = "_r5-i";
export var bubble = "_r5-2";
export var bubbleActionMenu = "_r5-j";
export var bubbleContext = "_r5-6";
export var bubbleItems = "_r5-7";
export var customer = "_r5-3";
export var divider = "_r5-8";
export var fileList = "_r5-9";
export var hiddenComment = "_r5-o";
export var infoAbove = "_r5-a";
export var internal = "_r5-4";
export var lightActionButton = "_r5-1";
export var link = "_r5-b";
export var merchant = "_r5-5";
export var message = "_r5-c";
export var profilePicture = "_r5-e";
export var quillToolbarContainer = "_r5-f";
export var senderDate = "_r5-g";
export var senderDateCustomer = "_r5-h";
export var senderName = "_r5-d";
export var time = "_r5-k";
export var uploadedImage = "_r5-l";
export var username = "_r5-m";
export var xsmall = "_r5-n";